import script from "./miniprogram-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./miniprogram-template.vue?vue&type=script&lang=ts&setup=true"

import "./miniprogram-template.vue?vue&type=style&index=0&id=e7816de2&lang=scss"

const __exports__ = script;

export default __exports__